// Cache for generated donut charts to improve cluster rendering performance
const chartCache = new Map();

// code for creating an SVG donut chart from feature properties
export function createDonutChart(props) {
	// Create a unique key for the props
	const cacheKey = props.map(p => `${p.cat_id}:${p.count}:${p.color}`).join('|');
	if (chartCache.has(cacheKey)) {
		return chartCache.get(cacheKey);
	}

	const offsets = [];
	const counts = [];
	const colors = [];
	
	for (const countObj of props) {
		counts.push(countObj);
		colors.push(countObj.color);
	}
	
	let total = 0;
	for (const count of counts) {
		offsets.push(total);
		total += count.count;
	}

	const fontSize =
		total >= 1000 ? 22 : total >= 100 ? 20 : total >= 10 ? 18 : 16;
	const r =
		total >= 1000 ? 50 : total >= 100 ? 32 : total >= 10 ? 24 : 18;
	const r0 = Math.round(r * 0.6);
	const w = r * 2;

	let html = `<svg width="${w}" height="${w}" xmlns="http://www.w3.org/2000/svg" viewbox="0 0 ${w} ${w}" text-anchor="middle" style="font: ${fontSize}px sans-serif; display: block">`;
	
	for (let i = 0; i < counts.length; i++) {
		html += donutSegment(offsets[i] / total, (offsets[i] + counts[i].count) / total, r, r0, colors[i]);
	}
	html += `<circle cx="${r}" cy="${r}" r="${r0}" fill="white" /><text dominant-baseline="central" transform="translate(${r}, ${r})">${total.toLocaleString()}</text></svg>`;
	
	chartCache.set(cacheKey, html);
	return html;
}

const dataUrlCache = new Map();

export function getDonutChartDataUrl(props) {
    const cacheKey = props.map(p => `${p.cat_id}:${p.count}:${p.color}`).join('|');
    if (dataUrlCache.has(cacheKey)) {
        return dataUrlCache.get(cacheKey);
    }
    const svg = createDonutChart(props);
    const dataUrl = `data:image/svg+xml;base64,${window.btoa(svg)}`;
    dataUrlCache.set(cacheKey, dataUrl);
    return dataUrl;
}

export function donutSegment(start, end, r, r0, color) {
	if (end - start === 1) end -= 0.00001;
	const a0 = 2 * Math.PI * (start - 0.25);
	const a1 = 2 * Math.PI * (end - 0.25);
	const x0 = Math.cos(a0),
		y0 = Math.sin(a0);
	const x1 = Math.cos(a1),
		y1 = Math.sin(a1);
	const largeArc = end - start > 0.5 ? 1 : 0;
	//console.log('start:');
	//console.log(start);
	//console.log('end');
	//console.log(end);
	//console.log('match check 2');
	//console.log(a0);
	//console.log(a1);
	//console.log(x0);
	//console.log(y0);
	//console.log(x1);
	//console.log(y1);
	//console.log(x1);
	//console.log(largeArc);
	// draw an SVG path
	return `<path d="M ${r + r0 * x0} ${r + r0 * y0} L ${r + r * x0} ${
		r + r * y0
	} A ${r} ${r} 0 ${largeArc} 1 ${r + r * x1} ${r + r * y1} L ${
		r + r0 * x1
	} ${r + r0 * y1} A ${r0} ${r0} 0 ${largeArc} 0 ${r + r0 * x0} ${
		r + r0 * y0
	}" fill="${color}" />`;
}
